import React from "react";
import {
  UserIcon,
  PhoneIcon,
  MailIcon,
  LocationMarkerIcon,
  IdentificationIcon,
} from "@heroicons/react/outline";

// Helper function to format address
const formatAddress = (address) => {
  if (!address) return "";
  if (typeof address === "string") return address;

  const parts = [];
  if (address.label) parts.push(address.label);
  if (address.line1) parts.push(address.line1);
  if (address.line2) parts.push(address.line2);
  if (address.city) parts.push(address.city);
  if (address.state) parts.push(address.state);
  if (address.pinCode) parts.push(address.pinCode);

  return parts.join(", ");
};

const CustomerInfo = ({ customer, className = "" }) => {
  if (!customer) {
    return (
      <div className={`bg-neutral-light rounded-lg p-4 ${className}`}>
        <p className="text-sm text-neutral-dark">No customer selected</p>
      </div>
    );
  }

  return (
    <div
      className={`bg-background border border-neutral-light rounded-lg p-4 ${className}`}
    >
      <div className="space-y-2">
        <div className="flex items-center">
          <UserIcon className="h-4 w-4 text-neutral-dark mr-2" />
          <div>
            <span className="text-sm font-medium text-text">
              {customer.name}
            </span>
            {customer.customerId && (
              <span className="ml-2 text-xs text-neutral-dark">
                ID: {customer.customerId}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center">
          <PhoneIcon className="h-4 w-4 text-neutral-dark mr-2" />
          <span className="text-sm text-text">{customer.phoneNumber}</span>
        </div>

        {customer.email && (
          <div className="flex items-center">
            <MailIcon className="h-4 w-4 text-neutral-dark mr-2" />
            <span className="text-sm text-text">{customer.email}</span>
          </div>
        )}

        {customer.customerId && (
          <div className="flex items-center">
            <IdentificationIcon className="h-4 w-4 text-neutral-dark mr-2" />
            <span className="text-sm text-text">{customer.customerId}</span>
          </div>
        )}

        {customer.address && (
          <div className="flex items-start">
            <LocationMarkerIcon className="h-4 w-4 text-neutral-dark mr-2 mt-0.5" />
            <span className="text-sm text-text">
              {formatAddress(customer.address)}
            </span>
          </div>
        )}

        {customer.kycVerified !== undefined && (
          <div className="mt-2">
            <span
              className={`text-xs px-2 py-1 rounded-full
              ${
                customer.kycVerified
                  ? "bg-success-light text-success-dark"
                  : "bg-warning-light text-warning-dark"
              }`}
            >
              {customer.kycVerified ? "KYC Verified" : "KYC Pending"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerInfo;
